window.addEventListener("load", (event) => {
  load();
});
const load = () => {
  const dayItems = document.querySelectorAll(".dayItem");
  for (let i = 0; i < dayItems.length; i++) {
    dayItems[i].addEventListener("click", switchDayOfWeek);
  }
  switchDisplay();
};

window.addEventListener("resize", function () {
  switchDisplay();
});

const switchDisplay = () => {
  if (window.innerWidth > 1024) {
    resetBlocks();
  } else {
    const currentActiveButton = document.querySelector(".active-button");
    const targetClassName = currentActiveButton.dataset.day;
    switchLessons(targetClassName);
  }
};

const switchDayOfWeek = (e) => {
  e.preventDefault;
  const currentActiveButton = document.querySelector(".active-button");
  const clickedButton = e.target;
  // ボタンのクラスを付け替える
  switchActiveButton(currentActiveButton, clickedButton);
  const targetClassName = clickedButton.dataset.day;
  if (window.innerWidth > 1024) return;
  // 同じ曜日のクラスに対してdisplay-noneを付与
  switchLessons(targetClassName);
};

const switchActiveButton = (activeButton, clickedButton) => {
  const className = "active-button";
  activeButton.classList.remove(className);
  clickedButton.classList.add(className);
};

const switchLessons = (className) => {
  const lessonBlocks = document.querySelectorAll(`.lesson-block`);
  const hiddenBlocks = Array.from(lessonBlocks).filter((block) => {
    return !block.classList.contains(className);
  });
  hiddenBlocks.forEach(function (block) {
    block.style.display = "none";
  });
  const shownBlocks = Array.from(lessonBlocks).filter((block) => {
    return block.classList.contains(className);
  });
  shownBlocks.forEach(function (block) {
    block.style.display = "block";
    block.style.width = "100%";
  });
};

const resetBlocks = () => {
  const lessonBlocks = document.querySelectorAll(`.lesson-block`);
  lessonBlocks.forEach(function (block) {
    block.style.display = "block";
    block.style.width = null;
  });
};
